var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Header() {
    return (_jsxs("div", __assign({ className: "space-y-2 border-b border-gray-200 pb-4" }, { children: [_jsx("div", __assign({ className: "flex items-center space-x-2" }, { children: _jsxs("button", __assign({ className: "text-gray-500 hover:text-gray-700 text-sm flex items-center" }, { children: [_jsx("span", __assign({ className: "mr-1" }, { children: "\u2039" })), " Voltar"] })) })), _jsx("h1", __assign({ className: "text-2xl font-semibold text-[#0f4098]" }, { children: "Registro de Ocorr\u00EAncias - Gov.pi Cidad\u00E3o" })), _jsx("p", __assign({ className: "text-gray-600 text-base" }, { children: "Preencha os campos abaixo e informe problemas que voc\u00EA encontrou ao usar o Gov.pi Cidad\u00E3o." }))] })));
}
